
























































































import Vue from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import config from "@/configs";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
  name: "LoginCard",
  components: {},
  data(): any {
    return {
      hasOtherLoginProviders: false,
      form: {
        email: null,
        password: null,
      },
    };
  },
  created() {
    if (this.$route.query.email) {
      this.form.email = this.$route.query.email;
    }
  },
  computed: {
    ...mapGetters("auth", { loading: "getLoading" }),
    ...mapGetters("snackbar", ["getVisibility"]),
    hideRegisterBtn(): boolean {
      return !config?.settings?.hideRegisterBtn;
    },
    isEmailSignIn(): boolean {
      return !!config?.settings?.signInEmailLink;
    },
    loginButtonLabel(): TranslateResult {
      return this.isEmailSignIn
        ? this.$t("common.sendEmailLink")
        : this.$t("common.login");
    },
  },
  methods: {
    ...mapActions("auth", ["login", "sendEmailLink"]),
    ...mapMutations("snackbar", ["setVisibility"]),
    doLogin() {
      if (this.isEmailSignIn) {
        this.sendEmailLink(this.form.email);
        this.form.email = null; //Clean the input
      } else {
        const payload = {
          ...this.form,
          token: this.$route.query.token,
        };
        this.login(payload);
      }
    },
  },
});
